module.exports = __webpack_public_path__ + "static/img/pc-web-img-02@m.15232c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/glovis-aa/pc-web-img-02@m.png
// module id = n1DW
// module chunks = 0